import React, { useEffect, useRef } from "react";
import SchoolAdminDashboard from "../schoolAdminDashboard";
import Container from "@material-ui/core/Container";
import { useParams } from "react-router-dom";
import { FormGroup } from "reactstrap";
import { getFromLocalStorage } from "../../../utils/webStorage";
import { formatPhoneNumber, formatContactNumber } from "../../../utils";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../../Validation/ValidationSchemas";
import { unFormatPhoneNumber } from "../../../Common/unFormatPhoneNumber";
import { useDispatch, useSelector } from "react-redux";
import CamelCaseString from "../../../Common/CamelCaseString";
import { openConfirmationPopup } from "../../../Redux/Actions/PopupActions";
import PageNotFoundPage from "../../../Common/PageNotFoundPage";
import CustomDropDown from "../../../Common/FormFields/CustomDropDown";
import CustomMultiSelectDropdown from "../../../Common/FormFields/CustomMultiSelectDropdown";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import { Checkbox } from "@mui/material";
import { BsCircle, BsFillCheckCircleFill } from "react-icons/bs";

import {
  getAllGroupList,
  resetGroupData,
  searchGroup,
  setGroupSearchQuery,
  setGroupSearchedRecord,
  setSelectedGroupsList,
} from "../../../Redux/Actions/GroupActions";
import {
  addCoach,
  getCoachData,
  getCoachPermissionList,
  getCoachSpecialityList,
  handleCoachLogoUpload,
  resetCoachData,
  selectOrRemoveCoachPermission,
  setCoachSpeciality,
  updateCoach,
} from "../../../Redux/Actions/CoachActions";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "../../../Common/ContentLayoutHeader";
import ImageUploadContainer from "../../../Common/FormFields/ImageUploadContainer";

const AddEditCoach = () => {
  const schoolId = getFromLocalStorage("schoolId");
  const currentUserId = getFromLocalStorage("currentUserId");
  const adminRole = getFromLocalStorage("loginRole");
  const { coachId } = useParams();
  const dispatch = useDispatch();
  const myref = useRef();
  const scrollRef = useRef();
  const loading = useSelector((state) => state?.CoachData?.loading);
  const currentSeason = useSelector(
    (state) => state.loggedInUser.userProfile.currentSeason
  );
  const coachData = useSelector((state) => state?.CoachData);

  const groupPageState = useSelector(
    (state) => state?.GroupsData?.groupPageState
  );
  const groupList = useSelector((state) => state?.GroupsData?.groupList);
  const selectedGroupList = useSelector(
    (state) => state?.GroupsData?.selectedGroupList
  );
  const scrollLoading = useSelector(
    (state) => state?.GroupsData?.loading?.scrollLoading
  );
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  const assignedRights = JSON.parse(
    getFromLocalStorage("assignedRights") || []
  ).map((item) => item.displayName);

  useEffect(() => {
    coachId && getCoachData(dispatch, { id: coachId });
    getCoachPermissionList(dispatch);
    getCoachSpecialityList(dispatch);
    getAllGroupList(dispatch, {
      schoolId,
      page: groupPageState?.page,
      size: groupPageState?.size,
    });

    return () => {
      resetCoachData(dispatch);
      resetGroupData(dispatch);
    };
  }, []);

  const handleSubmit = ({
    firstName,
    lastName,
    email,
    phoneNumber,
    speciality,
  }) => {
    if (!coachId) {
      addCoach(dispatch, {
        uploadId: coachData?.coachLogoId,
        firstName: CamelCaseString(firstName),
        lastName: CamelCaseString(lastName),
        email,
        phoneNumber: unFormatPhoneNumber(phoneNumber),
        speciality,
        groupIds: selectedGroupList.map((item) => item.id),
        schoolId,
        permissionRights: coachData?.selectedPermissionRights?.map(
          (item) => item.id
        ),
        sportsIds: [],
        currentUserId,
      });
    } else {
      updateCoach(dispatch, {
        id: coachId,
        uploadId: coachData?.coachLogoId,
        firstName: CamelCaseString(firstName),
        lastName: CamelCaseString(lastName),
        email,
        phoneNumber: unFormatPhoneNumber(phoneNumber),
        speciality: coachData?.coachData?.specialty,
        groupIds: selectedGroupList.map((item) => item.id),
        schoolId,
        permissionRights: coachData?.selectedPermissionRights?.map(
          (item) => item.id
        ),
        sportsIds: [],
        teamIds: [],
      });
    }
  };

  const checkRightsOrSports = (data) => {
    let selected = [...coachData?.selectedPermissionRights];
    const found = selected?.some((item) => item.id === data.id);
    found
      ? (selected = selected?.filter((item) => item.id !== data.id))
      : selected.push(data);
    selectOrRemoveCoachPermission(dispatch, selected);
  };

  const handleGroups = (value, isAdded) => {
    setSelectedGroupsList(dispatch, {
      selectedList: isAdded
        ? [...selectedGroupList, value]
        : selectedGroupList?.filter((el) => el.id !== value.id),
    });
  };

  const setSearchQueryOrSearchedRecord = (
    value,
    pageStateName,
    isSearchQuery
  ) => {
    if (isSearchQuery) {
      setGroupSearchQuery(dispatch, {
        pageStateName: pageStateName,
        searchQuery: value,
      });
    } else {
      setGroupSearchedRecord(dispatch, {
        pageStateName: pageStateName,
        status: value,
      });
    }
  };

  const onScrollGroupList = () => {
    if (groupPageState?.page < groupPageState?.totalPages && !scrollLoading) {
      if (scrollRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
        if (Math.round(scrollTop + clientHeight + 1) >= scrollHeight) {
          groupPageState?.searchedRecord
            ? searchGroup(dispatch, {
                searchQuery: groupPageState?.searchQuery,
                schoolId,
                page: groupPageState?.page,
                size: groupPageState?.pageSize,
              })
            : getAllGroupList(dispatch, {
                schoolId,
                page: groupPageState?.page,
                size: groupPageState?.pageSize,
              });
        }
      }
    }
  };

  const getDefaulData = (page) => {
    getAllGroupList(dispatch, {
      schoolId,
      page: page,
      size: 10,
    });
  };

  const handleGroupSearch = (value, page, size) => {
    searchGroup(dispatch, {
      searchQuery: value,
      schoolId,
      page: page,
      size: size,
    });
  };

  const checkSelectedGroups = () => {
    const filteredGroupList = groupList?.map((ol) => {
      const isSelected = selectedGroupList?.filter((el) => el.id === ol.id);
      return isSelected?.length > 0
        ? { ...ol, disabled: true }
        : { ...ol, disabled: false };
    });

    return filteredGroupList;
  };

  const setSearchQuery = (value) => {
    setSearchQueryOrSearchedRecord(value, "groupPageState", true);
  };

  const setSearchedRecord = (value) => {
    setSearchQueryOrSearchedRecord(value, "groupPageState", false);
  };

  const handleCancel = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Cancel?",
        btnColor: "red",
        btnText: "Yes",
        id: coachId,
        type: "Add / Edit Coach",
      },
    });
  };

  return (
    <Formik
      innerRef={myref}
      initialValues={{
        firstName: !coachId ? "" : coachData?.coachData?.firstName,
        lastName: !coachId ? "" : coachData?.coachData?.lastName,
        email: !coachId ? "" : coachData?.coachData?.email,
        phoneNumber: !coachId
          ? ""
          : formatPhoneNumber(coachData?.coachData?.phoneNumber),
        speciality: !coachId ? "" : coachData?.coachData?.specialty,
        groupIds: [],
        permissionRights: [],
      }}
      enableReinitialize
      validationSchema={validationSchema.coachFormValidation}
      onSubmit={(values) => handleSubmit(values)}
    >
      {(formik) => (
        <Form>
          <div>
            {(adminRole == "SCHOOL ADMIN" ||
              assignedRights.includes("Add / Remove Coaches")) &&
            currentSeason ? (
              <div
                // className="content-layout add-sectionn p-0 position-relative"
                className={
                  isDrawerOpen
                    ? "content-layout add-sectionn p-0 position-relative"
                    : "toggle-content-layout add-sectionn p-0 position-relative"
                }
              >
                <SchoolAdminDashboard />
                <ContentLayoutSpinner animate={loading?.pageLoading} />
                <ContentLayoutHeader
                  // heading={
                  //   coachId
                  //     ? `Edit : ${coachData?.coachData?.firstName} ${coachData?.coachData?.lastName}`
                  //     : "Add Coach"
                  // }
                  heading={
                    coachId
                      ? `Edit : ${
                          coachData?.coachData?.firstName ||
                          coachData?.coachData?.lastName
                            ? `${coachData?.coachData?.firstName || ""} ${
                                coachData?.coachData?.lastName || ""
                              }`
                            : "Coach"
                        }`
                      : "Add Coach"
                  }
                  handleCancel={handleCancel}
                  navigationLink={
                    coachId ? `/coachesdetails/${coachId}` : "/schoolcoaches"
                  }
                  btnText={coachId ? "Save" : "Add"}
                  loading={loading?.buttonLoading}
                  disabled={!formik.isValid}
                />
                <Container className="mg-top-70">
                  <form name="adminRegistrationForm" className="moboMargin-5">
                    <div className="row">
                      <div className="col-12 col-lg-5 col-md-10">
                        <div className="white-card2 ">
                          <ImageUploadContainer
                            id="upload-photo-1"
                            logoUrl={coachData?.coachLogo}
                            handleUpload={(file) =>
                              handleCoachLogoUpload(dispatch, {
                                file: file,
                                currentUserId: currentUserId,
                              })
                            }
                            label={
                              coachData?.coachLogo
                                ? "Update Profile Photo"
                                : "Add Profile Photo"
                            }
                            loading={loading?.profileImageLoading}
                          />
                        </div>
                        <div className="clear20"></div>
                        <div className="white-card2 ">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                              <FormikTextField
                                label="First Name"
                                formik={formik}
                                fieldName="firstName"
                                placeholder="Enter First name"
                                labelFontSize="fs-18"
                              />
                              <FormikTextField
                                label="Last Name"
                                formik={formik}
                                fieldName="lastName"
                                placeholder="Enter Last name"
                                labelFontSize="fs-18"
                              />
                              <FormikTextField
                                label="Email"
                                formik={formik}
                                fieldName="email"
                                placeholder="Enter Email Address"
                                labelFontSize="fs-18"
                                isDisabled={!coachId ? false : true}
                              />
                              <FormikTextField
                                label="Phone Number"
                                formik={formik}
                                fieldName="phoneNumber"
                                placeholder="Enter Phone Number"
                                labelFontSize="fs-18"
                                onKeyUp={(e) =>
                                  formatContactNumber(e.target.value, myref)
                                }
                                maxLength={14}
                              />
                              <FormGroup>
                                <label className="fmlabel mt-6 semi-bold fs-18">
                                  Select Speciality{" "}
                                  <span className="redstar">*</span>
                                </label>
                                <CustomDropDown
                                  selected={coachData?.coachData?.specialty}
                                  setSelected={(value) =>
                                    setCoachSpeciality(dispatch, value)
                                  }
                                  formik={formik}
                                  fieldName="speciality"
                                  defaultSelectOption="Select Speciality"
                                  options={coachData?.specialityList}
                                  fieldToShow="specialtyName"
                                  optionValue="specialtyName"
                                  isDisabled="disabled"
                                />
                              </FormGroup>
                              <FormGroup className="fs-14">
                                <label className="fmlabel mt-6 semi-bold fs-18">
                                  Groups <span className="redstar"></span>
                                </label>
                                <CustomMultiSelectDropdown
                                  defaultSelectOption="Select Groups"
                                  selected={selectedGroupList}
                                  setSelected={handleGroups}
                                  options={checkSelectedGroups()}
                                  fieldToShow="groupName"
                                  isDisabled="disabled"
                                  searchQuery={groupPageState?.searchQuery}
                                  setSearchQuery={setSearchQuery}
                                  searchedRecord={
                                    groupPageState?.searchedRecord
                                  }
                                  setSearchedRecord={setSearchedRecord}
                                  getDataByPage={getDefaulData}
                                  searchData={handleGroupSearch}
                                  onScroll={onScrollGroupList}
                                  ref={scrollRef}
                                />
                              </FormGroup>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-10 col-lg-7 ">
                        <div className="TeamAdmin">
                          <h6 className="team-title bold fs-18">
                            Assigned Team Admin Rights
                          </h6>
                          <div className="white-card2">
                            {coachData?.permissionRights?.map((data) => (
                              <div key={data.id} className="admin-role">
                                <Checkbox
                                  onChange={() =>
                                    checkRightsOrSports(
                                      data,
                                      coachData?.permissionRights,
                                      "rights"
                                    )
                                  }
                                  icon={
                                    <BsCircle fontSize="20px" color="#13005A" />
                                  }
                                  checkedIcon={
                                    <BsFillCheckCircleFill
                                      fontSize="20px"
                                      color="#13005A"
                                    />
                                  }
                                  checked={coachData?.selectedPermissionRights?.some(
                                    (item) => item.id === data.id
                                  )}
                                  className="rights-check-icon"
                                />
                                <h6 className="mx-2">{data.displayName}</h6>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </Container>
                <div className="clear20"></div>
              </div>
            ) : (
              <PageNotFoundPage />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AddEditCoach;
